import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader, Row, Col, Button, Input, Form, CustomInput, Label, FormGroup } from 'reactstrap';
import { postAPI, deleteAPI } from '../../Base/API';
import { BlankCard, MultiLangTextWithTitle } from '../../Base/Common/CommonUIComponents';
import { handleNotification } from "../../Base/Common/Notification";
import { FormattedMessage, injectIntl } from 'react-intl';
import IconPicker from './IconPicker';

class TagModal extends Component {
    static displayName = TagModal.name;
    _isMounted = false;

    constructor(props) {
        super(props);
        
        this.state = {
            block: false,
            tag: this.props.selectedTag || { multiLingual: [] },
        }
    }

    saveTag = (e) => {
        e.preventDefault();
        this.setState({ block: true });

        const body = this.state.tag;

        postAPI(result => {
            const { data, error } = result;
            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });
                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                }
                else if (data.response && data.response.length > 0) {
                    handleNotification(data, <FormattedMessage id="VoucherTags.TagSaved" />, <FormattedMessage id="generic.success" />);
                    this.props.updateTable(data.response[0], false);
                }

                this.setState({ block: false });
            }
            else this.setState({ block: false });
        }, '/api/Voucher/Voucher/v1/voucherTag', JSON.stringify({ request: body }));
    }

    removeTag = (e) => {
        e && e.preventDefault();
        this.setState({ block: true });

        deleteAPI(result => {
            const { data, error } = result;
            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });

                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                }
                else {
                    handleNotification(data, <FormattedMessage id="VoucherTags.TagDeleted" />, <FormattedMessage id="generic.success" />);
                    this.props.updateTable(this.state.tag, true);
                }

                this.setState({ block: false });
            }
            else this.setState({ block: false });
        }, '/api/Voucher/Voucher/v1/voucherTag/' + this.state.tag.id);
    }

    handleChange = (evt, lang) => {
        const multiLingual = [...this.state.tag.multiLingual] || [];
        const idx = multiLingual.indexOf(multiLingual.find(ml => ml.languageCode === lang));

        if (idx >= 0) {
            const ml = multiLingual[idx];
            ml[evt.target && evt.target.name] = evt.target && evt.target.value;
        }
        else {
            multiLingual.push({
                languageCode: lang,
                [evt.target && evt.target.name]: evt.target && evt.target.value
            });
        }
        
        this.setState(prevState => ({
            ...prevState,
            tag: {
                ...prevState.tag,
                multiLingual: multiLingual
            }
        }));
    }

    handleSwitch = (evt) => {
        const { id, checked } = evt.target;

        this.setState({
            tag: {
                ...this.state.tag,
                [id]: checked
            }
        });
    }

    handleIconSelect = ({ iconName, iconStyle }) => {
        this.setState({
            tag: {
                ...this.state.tag,
                iconName,
                iconStyle,
            }
        });
    }

    render() {
        const { tag } = this.state;

        return (
            <Modal isOpen={this.props.modal} toggle={this.props.toggleModal} fade={false} className="modal-xl" >
                <ModalHeader toggle={this.props.toggleModal}>
                    {tag.id ? <FormattedMessage id="VoucherTags.EditTag" /> : <FormattedMessage id="VoucherTags.CreateTag" />}
                </ModalHeader>
                <ModalBody className="modal-xl p-0">
                    <BlankCard block={this.state.block} error={this.state.error}>
                        <Form onSubmit={this.saveTag}>
                            <Row className="mb-2 align-items-center">
                                <Label sm={2}> <FormattedMessage id="VoucherTags.Status" /></Label>
                                <Col className="col-4">
                                    <CustomInput
                                        name="active"
                                        type="switch"
                                        id="active"
                                        checked={tag.active}
                                        onChange={(evt) => this.handleSwitch(evt)}
                                    />
                                </Col>
                                <Col className="text-right">
                                    {tag.id ?
                                        <Button className="btn-sm btn-host" onClick={this.removeTag}>
                                            <i className="fa-solid fa-trash-can" />
                                        </Button>
                                    : ''}
                                    <Button className="btn-sm btn-host ml-2" type="submit"> <i className="fa-solid fa-floppy-disk" /></Button>
                                </Col>
                            </Row>
                            <FormGroup row className="align-items-center">
                                <Label sm={2}> <FormattedMessage id="VoucherTags.Icon" /></Label>
                                <Col sm={4}>
                                    <IconPicker
                                        iconName={tag.iconName || ''}
                                        iconStyle={tag.iconStyle || 'solid'}
                                        onSelect={this.handleIconSelect}
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={2}> <FormattedMessage id="generic.Translations" /></Label>
                                <Col className="col-10">                                    
                                    <MultiLangTextWithTitle
                                        titleFieldName="code"
                                        textList={tag.multiLingual}
                                        updateTitle={this.handleChange}
                                        udpateDescription={this.handleChange}
                                        hasShortDesc={false}
                                        plainDescription={true}
                                    />
                                </Col>
                            </FormGroup>
                        </Form>
                    </BlankCard>
                </ModalBody>
            </Modal>
        );
    }
}
export default injectIntl(TagModal);